export default function stringParseClone(deepObject: any) {
  return JSON.parse(JSON.stringify(deepObject));
}
